module.exports = __webpack_public_path__ + "static/img/143_TO8_1846_og.628ed6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/143_TO8_1846_og.jpg
// module id = nRPG
// module chunks = 0